export const GET_DEPARTMENT_SERVICES_DATA="GET_DEPARTMENT_SERVICES_DATA";
export const GET_DEPARTMENT_SERVICES_SUCCESS="GET_DEPARTMENT_SERVICES_SUCCESS";
export const GET_DEPARTMENT_SERVICES="GET_DEPARTMENT_SERVICES";